// extracted by mini-css-extract-plugin
export var infoItem = "_qp-2";
export var title = "_qp-0";
export var value = "_qp-1";